import { SVGProps } from "react";

export const UserProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.32757 14.2316C2.9128 15.074 -0.796635 16.7941 1.46266 18.9466C2.56631 19.998 3.79549 20.75 5.34087 20.75H14.1591C15.7045 20.75 16.9337 19.998 18.0373 18.9466C20.2966 16.7941 16.5872 15.074 15.1724 14.2316C11.8548 12.2561 7.64519 12.2561 4.32757 14.2316Z"
      stroke={props.color || "#1A1C1F"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.25 5.25C14.25 7.73528 12.2353 9.75 9.75 9.75C7.26472 9.75 5.25 7.73528 5.25 5.25C5.25 2.76472 7.26472 0.75 9.75 0.75C12.2353 0.75 14.25 2.76472 14.25 5.25Z"
      stroke={props.color || "#1A1C1F"}
      stroke-width="1.5"
    />
  </svg>
);
